import {
  createRouter,
  createWebHistory
} from "vue-router";

const routes = [{
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
  },
  //产品服务
  {
    path: "/productService",
    name: "productService",
    component: () => import("../views/productService.vue"),
  },
  //产品服务详情
  {
    path: "/productServiceDetails",
    name: "productServiceDetails",
    component: () => import("../views/productServiceDetails.vue"),
  },
  //优秀案例
  {
    path: "/excellentCase",
    name: "excellentCase",
    component: () => import("../views/excellentCase.vue"),
  },
  //优秀案例详情
  {
    path: "/excellentCaseDetails",
    name: "excellentCaseDetails",
    component: () => import("../views/excellentCaseDetails.vue"),
  },
  //新闻动态
  {
    path: "/newsDynamics",
    name: "newsDynamics",
    component: () => import("../views/newsDynamics.vue"),
  },
  //新闻详情
  {
    path: "/newsDynamicsDetails",
    name: "newsDynamicsDetails",
    component: () => import("../views/newsDynamicsDetails.vue"),
  },
  //招标公告
  {
    path: "/tenderAnnouncement",
    name: "tenderAnnouncement",
    component: () => import("../views/tenderAnnouncement.vue"),
  },
  //招标公告详情
  {
    path: "/tenderAnnouncementDetails",
    name: "tenderAnnouncementDetails",
    component: () => import("../views/tenderAnnouncementDetails.vue"),
  },
  //中标公告
  {
    path: "/bidWinningAnnouncement",
    name: "bidWinningAnnouncement",
    component: () => import("../views/bidWinningAnnouncement.vue"),
  },
  //中标公告详情
  {
    path: "/bidWinningAnnouncementDetails",
    name: "bidWinningAnnouncementDetails",
    component: () => import("../views/bidWinningAnnouncementDetails.vue"),
  },
  //澄清公告详情
  {
    path: "/clarifyAnnouncementDetails",
    name: "clarifyAnnouncementDetails",
    component: () => import("../views/clarifyAnnouncementDetails.vue"),
  },
  //预公告详情
  {
    path: "/preAnnouncementDetails",
    name: "preAnnouncementDetails",
    component: () => import("../views/preAnnouncementDetails.vue"),
  },
  //搜索结果
  {
    path: "/search",
    name: "search",
    component: () => import("../views/search.vue"),
  },
  //公司介绍
  {
    path: "/companyIntroduction",
    name: "companyIntroduction",
    component: () => import("../views/companyIntroduction.vue"),
  },
  {
    path: "/announcement",
    name: "announcement",
    component: () => import("../views/tenderAnnouncement.vue"),
  },
  // {
  //   path: '/informationPersonMap',
  //  name: 'informationPersonMap',
  //   component: () => import('../views/informationPersonMap.vue')
  // },

  // 配置通配符路由
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: '/'
  // }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;